import React from 'react'

import TeaserCard from 'components/TeaserCard'

import teaserImageSrc from './application-teaser.png'

const ApplicationTeaser = () => (
  <TeaserCard
    header="Unlock Applying with Scoir"
    message="It looks like your institution has not signed up to receive applications through Scoir yet. At this time, applying with Scoir is available exclusively to current and eligible Coalition for College member institutions."
    imageSrc={teaserImageSrc}
    imageAltText="Unlock Application Settings"
    requestAccessHref="https://www.scoir.com/new-product-integration"
    requestAccessText="Find Out More"
    showSupportMessage={true}
  />
)

export default ApplicationTeaser
